import m from "../../es2015/lang/hr_HR";
window.am4lang_hr_HR = m;


//////////////////
// WEBPACK FOOTER
// ./lang/hr_HR.js
// module id = null
// module chunks = 